import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from './translations.json';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [isRTL, setIsRTL] = useState(false);

  useEffect(() => {
    // Apply RTL styling when Arabic is selected
    if (currentLanguage === 'ar') {
      document.body.style.direction = 'rtl';
      document.body.classList.add('rtl');
      setIsRTL(true);
    } else {
      document.body.style.direction = 'ltr';
      document.body.classList.remove('rtl');
      setIsRTL(false);
    }
  }, [currentLanguage]);

  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode);
    localStorage.setItem('selectedLanguage', langCode);
  };

  // Load saved language on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage && translations[savedLanguage]) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const t = (key, params = {}) => {
    let translation = translations[currentLanguage]?.[key] || translations['en'][key] || key;
    
    // Replace parameters in translation
    Object.keys(params).forEach(param => {
      translation = translation.replace(`{${param}}`, params[param]);
    });
    
    return translation;
  };

  const getCurrentLanguageDisplay = () => {
    return currentLanguage === 'en' ? { flag: '🇺🇸', text: 'EN' } : { flag: '🇸🇦', text: 'AR' };
  };

  return (
    <LanguageContext.Provider value={{
      currentLanguage,
      changeLanguage,
      t,
      isRTL,
      getCurrentLanguageDisplay
    }}>
      {children}
    </LanguageContext.Provider>
  );
};
